import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '../../../Common/Toggle/Toggle';
import { MAX_NUM_GOALGROUPS } from '../../../../constants/constants';
import SubscriptionGoals from '../../SubscriptionGoals';

export const GoalsSection = (props) => {

    const onActiveChange = (name, isChecked) => {
        props.onFormChange(name, isChecked);
    }

    const removeGoalGroup = (index) => {
        let goalGroups = props.subscription.goalGroups.slice();
        goalGroups.splice(index, 1);
        if(goalGroups.length === 0){
            goalGroups.push({
                id: 0,
                name: '',
                isActive: true,
                ordinal: 0,
                subscriptionId: props.subscription.id,
                goals: []
            });
        }
        props.onFormChange("goalGroups", goalGroups);
    }

    const className = props.isFormValid ? "goals-form" : "goals-form was-validated"
    return (
        <div className="goals-section section">
            <form className={className} noValidate>
                <div className="row content">
                    <div className="col-12 col-md-4 header">
                        <h4>Goals</h4>
                        <p>Your teams can track specific goals on the Dashboard. Each goal group can contain one or two goals, each with up to three metrics.</p>
                    </div>
                    <div className="col-12 col-md-8 fields">
                        <div className="row">
                            <div className="col-12 col-lg-6">
                                <Toggle name="isGoalWidgetActive" text="Display Goals Section on Dashboard" checked={props.subscription.isGoalWidgetActive} onChange={onActiveChange} />
                            </div>
                            <div className="col-12 col-lg-6">
                                {props.subscription.isGoalWidgetActive &&
                                    <SubscriptionGoals 
                                            subscription={props.subscription}
                                            removeGoalGroup={removeGoalGroup}
                                            maxNumGoalGroups={MAX_NUM_GOALGROUPS}
                                            updateSubscription={props.onFormChange}
                                    />            
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

GoalsSection.propTypes = {
    subscription: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    onFormChange: PropTypes.func.isRequired
};


export default GoalsSection;

